import { actions } from './action'

const initialState = {
  attendancePercentage: null,
  pendingPayroll: null,
  pendingException: null,
  pendingExpense: null,
  pendingReimbursement: null,
  pendingOnboarding: null,
  topPerformerList: [],
  leaveTaken: null,
  empPunchLogs: [],
  empCalPunches: [],
}
const onDashboard = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_ATTENDANCE_PERCENTAGE:
      return {
        ...state,
        attendancePercentage: action.payload.attendancePercentage,
      }
    case actions.GET_PENDING_PAYROLL:
      return {
        ...state,
        pendingPayroll: action.payload.pendingPayroll,
      }
    case actions.GET_PENDING_EXCEPTION:
      return {
        ...state,
        pendingException: action.payload.pendingException,
      }
    case actions.GET_PENDING_EXPENSE:
      return {
        ...state,
        pendingExpense: action.payload.pendingExpense,
      }
    case actions.GET_PENDING_REIMBURSEMENT:
      return {
        ...state,
        pendingReimbursement: action.payload.pendingReimbursement,
      }
    case actions.GET_PENDING_ONBOARDING:
      return {
        ...state,
        pendingOnboarding: action.payload.pendingOnboarding,
      }
    case actions.GET_PERFORMER_LIST:
      return {
        ...state,
        topPerformerList: action.payload.topPerformerList,
      }
    case actions.GET_LEAVE_TAKEN:
      return {
        ...state,
        leaveTaken: action.payload.leaveTaken,
      }
    case actions.GET_EMP_PUNCH_LOGS:
      return {
        ...state,
        empPunchLogs: action.payload.empPunchLogs,
      }
    case actions.GET_EMP_CALENDAR_PUNCH_LOGS:
      return {
        ...state,
        empCalPunches: action.payload.empCalPunches,
      }

    default:
      return state
  }
}
export default onDashboard
